export default __webpack_public_path__ + "static/media/cripplinglaceration.ee3dafde.png";